/*----------------------------------
  トップページ/JavaScript
------------------------------------*/
// 画面幅が374px以下のときviewportを375pxに固定するためのハック
const viewport = document.querySelector('meta[name="viewport"]');
const switchViewport = () => {
  const value =
    window.outerWidth > 374
      ? "width=device-width,initial-scale=1"
      : "width=375";
  if (viewport.getAttribute("content") !== value) {
    viewport.setAttribute("content", value);
  }
};
window.addEventListener("resize", switchViewport);
switchViewport();

/*----------------------------------
  jQuery
------------------------------------*/
jQuery(function ($) {
  /*----------------------------------
    メインビジュアルの横スクロールの初期値を中央付近にする
  ------------------------------------*/
  $(document).ready(function () {
    $(".js-mv").scrollLeft(768 / 4);
  });
});
